import React from 'react';
import { useNavigate } from 'react-router-dom';
import './NotFound.css';
import Header from '../components/Secciones/Header';
import Footer from '../components/Secciones/Footer';

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div>
        <Header />
        <div className="notfound-root">
            <div className="notfound-card">
                <h1 className="notfound-code">404</h1>
                <h2 className="notfound-title">Page Not Found</h2>
                <p className="notfound-desc">
                This page is not available! Try again.
                </p>

                <div className="notfound-actions">
                <button className="btn" onClick={() => navigate('/')}>
                    Return Home
                </button>

                <button
                    className="btn btn-secondary-notfound"
                    onClick={() => {
                    navigate('/search');
                    }}
                >
                    Search Products
                </button>
                </div>
            </div>
        </div>
        <Footer />
    </div>
  );
};

export default NotFound;